export const HUBSPOT_DEFINED = 'HUBSPOT_DEFINED';
export const USER_DEFINED = 'USER_DEFINED';
export const INTEGRATOR_DEFINED = 'INTEGRATOR_DEFINED';
export const EffectiveDateOptions = {
  TODAY: 'TODAY',
  YESTERDAY: 'YESTERDAY',
  THIS_WEEK: 'THIS_WEEK',
  LAST_WEEK: 'LAST_WEEK',
  THIS_MONTH: 'THIS_MONTH',
  LAST_MONTH: 'LAST_MONTH',
  THIS_QUARTER: 'THIS_QUARTER',
  LAST_QUARTER: 'LAST_QUARTER',
  THIS_YEAR: 'THIS_YEAR',
  LAST_YEAR: 'LAST_YEAR',
  LAST_7_DAYS: 'LAST_7_DAYS',
  LAST_14_DAYS: 'LAST_14_DAYS',
  LAST_30_DAYS: 'LAST_30_DAYS',
  LAST_60_DAYS: 'LAST_60_DAYS',
  LAST_90_DAYS: 'LAST_90_DAYS',
  LAST_180_DAYS: 'LAST_180_DAYS',
  LAST_365_DAYS: 'LAST_365_DAYS'
};
export const ContractChangeStatus = {
  DRAFT: 'DRAFT',
  PROPOSED: 'PROPOSED',
  ACCEPTED: 'ACCEPTED',
  EXPIRED: 'EXPIRED',
  CANCELED: 'CANCELED'
};
export const ContractChangeType = {
  INITIAL: 'INITIAL',
  CHANGE: 'CHANGE',
  RENEWAL: 'RENEWAL'
};